export var ChainKey;
(function (ChainKey) {
    // EVM
    ChainKey["ETH"] = "eth";
    ChainKey["POL"] = "pol";
    ChainKey["BSC"] = "bsc";
    ChainKey["DAI"] = "dai";
    ChainKey["FTM"] = "ftm";
    ChainKey["AVA"] = "ava";
    ChainKey["ARB"] = "arb";
    ChainKey["OPT"] = "opt";
    ChainKey["ONE"] = "one";
    ChainKey["FSN"] = "fsn";
    ChainKey["MOR"] = "mor";
    ChainKey["CEL"] = "cel";
    ChainKey["FUS"] = "fus";
    ChainKey["TLO"] = "tlo";
    ChainKey["CRO"] = "cro";
    ChainKey["BOB"] = "bob";
    ChainKey["RSK"] = "rsk";
    ChainKey["VEL"] = "vel";
    ChainKey["MOO"] = "moo";
    ChainKey["MAM"] = "mam";
    ChainKey["AUR"] = "aur";
    ChainKey["EVM"] = "evm";
    ChainKey["ARN"] = "arn";
    ChainKey["ERA"] = "era";
    ChainKey["PZE"] = "pze";
    ChainKey["LNA"] = "lna";
    ChainKey["BAS"] = "bas";
    ChainKey["SCL"] = "scl";
    ChainKey["MOD"] = "mod";
    ChainKey["MNT"] = "mnt";
    ChainKey["BLS"] = "bls";
    ChainKey["SEI"] = "sei";
    ChainKey["FRA"] = "fra";
    ChainKey["TAI"] = "tai";
    ChainKey["GRA"] = "gra";
    ChainKey["IMX"] = "imx";
    ChainKey["KAI"] = "kai";
    ChainKey["XLY"] = "xly";
    ChainKey["OPB"] = "opb";
    ChainKey["WCC"] = "wcc";
    ChainKey["LSK"] = "lsk";
    ChainKey["ABS"] = "abs";
    ChainKey["BER"] = "ber";
    ChainKey["SON"] = "son";
    ChainKey["UNI"] = "uni";
    ChainKey["APE"] = "ape";
    ChainKey["SOE"] = "soe";
    ChainKey["INK"] = "ink";
    ChainKey["LNS"] = "lns";
    ChainKey["SWL"] = "swl";
    ChainKey["CRN"] = "crn";
    ChainKey["ETL"] = "etl";
    ChainKey["SUP"] = "sup";
    ChainKey["HYP"] = "hyp";
    ChainKey["XDC"] = "xdc";
    ChainKey["BOC"] = "boc";
    ChainKey["VIC"] = "vic";
    ChainKey["FLR"] = "flr";
    ChainKey["KAT"] = "kat";
    ChainKey["VAN"] = "van";
    ChainKey["RON"] = "ron";
    ChainKey["PLU"] = "plu";
    ChainKey["NIB"] = "nib";
    ChainKey["HPL"] = "hpl";
    ChainKey["SOP"] = "sop";
    ChainKey["PLA"] = "pla";
    ChainKey["FLW"] = "flw";
    ChainKey["HMI"] = "hmi";
    ChainKey["MON"] = "mon";
    // None-EVM
    ChainKey["SOL"] = "sol";
    ChainKey["TER"] = "ter";
    ChainKey["OAS"] = "oas";
    // MVM
    ChainKey["SUI"] = "sui";
    // UTXO
    ChainKey["BTC"] = "btc";
    ChainKey["BCH"] = "bch";
    ChainKey["LTC"] = "ltc";
    ChainKey["DGE"] = "dge";
    // Tron
    ChainKey["TRN"] = "trn";
})(ChainKey || (ChainKey = {}));
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["ETH"] = 1] = "ETH";
    ChainId[ChainId["POL"] = 137] = "POL";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["DAI"] = 100] = "DAI";
    ChainId[ChainId["FTM"] = 250] = "FTM";
    ChainId[ChainId["AVA"] = 43114] = "AVA";
    ChainId[ChainId["ARB"] = 42161] = "ARB";
    ChainId[ChainId["OPT"] = 10] = "OPT";
    ChainId[ChainId["ONE"] = 1666600000] = "ONE";
    ChainId[ChainId["FSN"] = 32659] = "FSN";
    ChainId[ChainId["MOR"] = 1285] = "MOR";
    ChainId[ChainId["CEL"] = 42220] = "CEL";
    ChainId[ChainId["FUS"] = 122] = "FUS";
    ChainId[ChainId["TLO"] = 40] = "TLO";
    ChainId[ChainId["CRO"] = 25] = "CRO";
    ChainId[ChainId["BOB"] = 288] = "BOB";
    ChainId[ChainId["RSK"] = 30] = "RSK";
    ChainId[ChainId["VEL"] = 106] = "VEL";
    ChainId[ChainId["MOO"] = 1284] = "MOO";
    ChainId[ChainId["MAM"] = 1088] = "MAM";
    ChainId[ChainId["AUR"] = 1313161554] = "AUR";
    ChainId[ChainId["EVM"] = 9001] = "EVM";
    ChainId[ChainId["ARN"] = 42170] = "ARN";
    ChainId[ChainId["ERA"] = 324] = "ERA";
    ChainId[ChainId["PZE"] = 1101] = "PZE";
    ChainId[ChainId["LNA"] = 59144] = "LNA";
    ChainId[ChainId["BAS"] = 8453] = "BAS";
    ChainId[ChainId["SCL"] = 534352] = "SCL";
    ChainId[ChainId["MOD"] = 34443] = "MOD";
    ChainId[ChainId["MNT"] = 5000] = "MNT";
    ChainId[ChainId["BLS"] = 81457] = "BLS";
    ChainId[ChainId["SEI"] = 1329] = "SEI";
    ChainId[ChainId["FRA"] = 252] = "FRA";
    ChainId[ChainId["TAI"] = 167000] = "TAI";
    ChainId[ChainId["GRA"] = 1625] = "GRA";
    ChainId[ChainId["IMX"] = 13371] = "IMX";
    ChainId[ChainId["KAI"] = 8217] = "KAI";
    ChainId[ChainId["XLY"] = 196] = "XLY";
    ChainId[ChainId["OPB"] = 204] = "OPB";
    ChainId[ChainId["WCC"] = 480] = "WCC";
    ChainId[ChainId["LSK"] = 1135] = "LSK";
    ChainId[ChainId["ABS"] = 2741] = "ABS";
    ChainId[ChainId["BER"] = 80094] = "BER";
    ChainId[ChainId["SON"] = 146] = "SON";
    ChainId[ChainId["UNI"] = 130] = "UNI";
    ChainId[ChainId["APE"] = 33139] = "APE";
    ChainId[ChainId["SOE"] = 1868] = "SOE";
    ChainId[ChainId["INK"] = 57073] = "INK";
    ChainId[ChainId["LNS"] = 232] = "LNS";
    ChainId[ChainId["SWL"] = 1923] = "SWL";
    ChainId[ChainId["CRN"] = 21000000] = "CRN";
    ChainId[ChainId["ETL"] = 42793] = "ETL";
    ChainId[ChainId["SUP"] = 55244] = "SUP";
    ChainId[ChainId["HYP"] = 999] = "HYP";
    ChainId[ChainId["XDC"] = 50] = "XDC";
    ChainId[ChainId["BOC"] = 60808] = "BOC";
    ChainId[ChainId["VIC"] = 88] = "VIC";
    ChainId[ChainId["FLR"] = 14] = "FLR";
    ChainId[ChainId["KAT"] = 747474] = "KAT";
    ChainId[ChainId["VAN"] = 1480] = "VAN";
    ChainId[ChainId["RON"] = 2020] = "RON";
    ChainId[ChainId["PLU"] = 98866] = "PLU";
    ChainId[ChainId["NIB"] = 6900] = "NIB";
    ChainId[ChainId["HPL"] = 1337] = "HPL";
    ChainId[ChainId["SOP"] = 50104] = "SOP";
    ChainId[ChainId["PLA"] = 9745] = "PLA";
    ChainId[ChainId["FLW"] = 747] = "FLW";
    ChainId[ChainId["HMI"] = 43111] = "HMI";
    ChainId[ChainId["MON"] = 143] = "MON";
    // None-EVM (IDs are made up by the LI.FI team)
    ChainId[ChainId["SOL"] = 1151111081099710] = "SOL";
    ChainId[ChainId["TER"] = 1161011141099710] = "TER";
    ChainId[ChainId["OAS"] = 111971151099710] = "OAS";
    // MVM (IDs are made up by the LI.FI team)
    ChainId[ChainId["SUI"] = 9270000000000000] = "SUI";
    // UTXO (IDs are made up by the LI.FI team)
    ChainId[ChainId["BTC"] = 20000000000001] = "BTC";
    ChainId[ChainId["BCH"] = 20000000000002] = "BCH";
    ChainId[ChainId["LTC"] = 20000000000003] = "LTC";
    ChainId[ChainId["DGE"] = 20000000000004] = "DGE";
    // Tron
    ChainId[ChainId["TRN"] = 728126428] = "TRN";
})(ChainId || (ChainId = {}));
//# sourceMappingURL=base.js.map